import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { patientDetailOrdersapi } from "../network/Network";
import { useSelector } from "react-redux";

const UserMyOrderDetail = () => {
  const token = useSelector((state) => state?.Auth?.token);
  let currentUrl = window.location.href.split("/");
  const [orderdetail, setGetorderdetail] = useState("");

  // Get Order_Detail Api 
  useEffect(() => {
    patientDetailOrdersapi(currentUrl[4], token).then((res) => {
      setGetorderdetail(res?.data);
    });
  }, [currentUrl[4]]);
  // =====================

  return (
    <>
      <Header />
      <PageHeader pagename="User Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <UserProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link to="/my-order">
                      <div className="nav-anchor">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>
                    </Link>
                  </div>
                  <div className="d-flex align-items-center w-100 justify-content-between">
                    <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                      Order ID: {orderdetail?.order_id}
                    </h5>
                    <h4 className="main-heading level-6 main-heading-font dark-color mb-0">
                      Status: {orderdetail?.status}
                    </h4>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-lg-4">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
                      <h4 className="primary-medium-font level-7 ">
                        laudantium otam{" "}
                      </h4>
                      <h5 className="primary-medium-font level-8 extra-color-15">
                        Qty: 05
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
                      <h4 className="primary-medium-font level-7 ">
                        laudantium otam{" "}
                      </h4>
                      <h5 className="primary-medium-font level-8 extra-color-15">
                        Qty: 05
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
                      <h4 className="primary-medium-font level-7 ">
                        laudantium otam{" "}
                      </h4>
                      <h5 className="primary-medium-font level-8 extra-color-15">
                        Qty: 05
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="row border-top pt-4 border-bottom pb-4">
                  <div className="col-lg-12">
                    <div className="order-detail-content">
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="details-pharmacy">
                            <h4 className="main-heading-font level-6 ">
                              Pharmacy Name:
                            </h4>
                            <h5 className="primary-medium-font level-8 extra-color-10">
                              {orderdetail?.pharmacy_detail?.name}
                            </h5>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="details-pharmacy">
                            <h4 className="main-heading-font level-6 ">
                              Pharmacy Contact:
                            </h4>
                            <h5 className="primary-medium-font level-8 extra-color-10">
                              {orderdetail?.pharmacy_detail?.phone}
                            </h5>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="details-pharmacy extra-bg-14 radius-40 p-2 text-center">
                            <h4 className="main-heading-font level-6 mb-0">
                              Delivery Type: {orderdetail?.order_type}
                            </h4>
                          </div>
                        </div>
                        <div className="col-lg-12 mt-4">
                          <div className="details-pharmacy">
                            <h4 className="main-heading-font level-6 ">
                              Pharmacy Address:
                            </h4>
                            <h5 className="primary-medium-font level-8 extra-color-10">
                              {orderdetail?.pharmacy_detail?.address}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="billing-detail">
                  <h4 className="main-heading-font level-6 mt-4">
                    Billing Details:
                  </h4>
                  <div className="row mt-3">
                    <div className="col-lg-4 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">First Name:</span>{" "}
                        {orderdetail?.billing_detail?.first_name}
                      </h4>
                    </div>
                    <div className="col-lg-4 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Last Name:</span>{" "}
                        {orderdetail?.billing_detail?.last_name}
                      </h4>
                    </div>
                    <div className="col-lg-4"></div>
                    <div className="col-lg-4 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Email:</span>{" "}
                        {orderdetail?.billing_detail?.email}
                      </h4>
                    </div>
                    <div className="col-lg-4 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Phone:</span>{" "}
                        {orderdetail?.billing_detail?.phone}
                      </h4>
                    </div>
                    <div className="col-lg-4"></div>
                    <div className="col-lg-12 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Address:</span>{" "}
                        {orderdetail?.billing_detail?.address}
                      </h4>
                    </div>
                    <div className="col-lg-3 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">City:</span>{" "}
                        {orderdetail?.billing_detail?.city}
                      </h4>
                    </div>
                    <div className="col-lg-3 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">State:</span>{" "}
                        {orderdetail?.billing_detail?.state}
                      </h4>
                    </div>
                    <div className="col-lg-3 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Country:</span>{" "}
                        {orderdetail?.billing_detail?.country}
                      </h4>
                    </div>
                    <div className="col-lg-3 mb-2">
                      <h4 className="primary-medium-font level-8 extra-color-10">
                        <span className="f_w_b">Zip Code:</span>{" "}
                        {orderdetail?.billing_detail?.zip_code}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserMyOrderDetail;
